<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <side-bar>
      <user-menu></user-menu>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'nc-icon nc-chart-pie-35',
            path: '/dashboard',
          }">
        </sidebar-item>
        <sidebar-item :link="{ name: 'Libros', icon: 'nc-icon nc-paper-2' }">
          <sidebar-item :link="{ name: 'Títulos físicos', path: '/books/manage' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Títulos Amazon', path: '/books/amazon' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Tirajes', path: '/books/runs' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Autores', path: '/books/authors' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: 'Transacciones', icon: 'nc-icon nc-bullet-list-67' }">
          <sidebar-item :link="{ name: 'Consignas', path: '/transactions/manage' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Ventas', path: '/transactions/sales' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Ventas Amazon', path: '/transactions/amazon' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: 'Reportes', icon: 'nc-icon nc-notes' }">
          <sidebar-item :link="{ name: 'Movimientos', path: '/reports/transactions' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Ubicación a la fecha', path: '/reports/location' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Mejores puntos', path: '/reports/pos' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Ganancias', path: '/reports/profit' }"></sidebar-item>
          <sidebar-item :link="{ name: 'Resumen por ubicación', path: '/reports/summary' }"></sidebar-item>
        </sidebar-item>
        <template v-if="user.role === 'Administrador'">
          <sidebar-item :link="{ name: 'Usuarios', icon: 'nc-icon nc-single-02' }">
            <sidebar-item :link="{ name: 'Administración', path: '/users/manage' }"></sidebar-item>
          </sidebar-item>
        </template>
        
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
import UserMenu from "./Extra/UserMenu.vue";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    UserMenu,
  },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("main-panel");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
  },
  mounted() {
    this.initScrollbar();
  },
};
</script>
